const RutaProtegida = () => {
  return (
    <>
      <h1>Bienvenido a la ruta protegida 😁</h1>
    </>
  );
};

export default RutaProtegida;
